import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@app/core/authentication";
import { MenuToggleService, Role, RouteInfo, User } from "@app/shared/common";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  /**
   * @description
   * Main sidebar navigation for application.
   * All menu items are provided by NGRX store config
   */

  /**
   * * General
   * @expand Expand/collapse sidebar menu
   * @menuItems All sidebar menu items
   * @subscriptions Subscriptions array
   * @cmsLogo Path to logo on server
   * @mediaUrl Path where all upload media are stored on server
   * @innerWidth Browser width
   */
  expand = false;
  menuItems: RouteInfo[] = [];
  subscriptions: Subscription[] = [];
  cmsLogo: string;
  mediaUrl: string;
  innerWidth: number;
  curentUser: User;

  constructor(
    private menuToggle: MenuToggleService,
    private router: Router,
    public authService: AuthService,
    private store: Store<{ config: any }>
  ) {
    /**
     * Get config from ngrx store
     */
    this.subscriptions.push(
      store.select("config").subscribe((res) => {
        this.mediaUrl = res.mediaUrl;
        this.menuItems = JSON.parse(JSON.stringify(res.sidebarRoutes));
      })
    );
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;
    this.innerWidth = window.innerWidth;
    // this.expand = this.innerWidth < 500 ? true : false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  /**
   * Expand/collapse sidebar menu
   */
  collapseMenu() {
    this.expand = !this.expand;
    this.menuToggle.changeState(this.expand);
  }

  /**
   * Open/close some of sidebar menu dropdowns
   * @param menuItem Menu item data
   * @param index Index of menu item
   */
  toggleDropdown(menuItem: any, index: number) {
    this.menuItems.forEach((item: any, i) => {
      if (index !== i) {
        item.opened = false;
      }
    });
    this.menuItems[index].opened = !menuItem.opened;
  }
}
